import { render, staticRenderFns } from "./UpdateDistributorModal.vue?vue&type=template&id=18f4ccf1"
import script from "./UpdateDistributorModal.vue?vue&type=script&lang=js"
export * from "./UpdateDistributorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports